import { store } from "src/redux/store";
import { Mixpanel } from "./Mixpanel";
type Props = {
  eventName: string;
  moduleName: string;
};
const MixpanelLockModules = ({ ...props }: Props) => {
  const { sub, email } = store.getState()?.credential?.userTokenDecode;
  const { eventName, moduleName } = props;
  const ORGANIZATION_ID = localStorage.getItem("company_id");

  if (eventName === "Locked Module") {
    Mixpanel.identify(email, false);
    const event_props = {
      $module_name: moduleName,
      $id: sub,
      $email: email,
      company_id: ORGANIZATION_ID,
    };
    Mixpanel.track(eventName, event_props);
  }
};

export default MixpanelLockModules;
